import fetcher from 'api/fetcher';

import { setAccountsBalance } from 'store/models/accounts';
import type { Balance } from 'store/models/balance';
import { AppThunkAction } from 'store/utils';

export const fetchAccountsBalance = (): AppThunkAction => {
    return (dispatch) => {
        return fetcher.get<unknown, Record<string, Balance>>('/api/v1/account/accounts_balance').then((balance) => {
            dispatch(setAccountsBalance(balance));
        });
    };
};
